import ITemplate from 'lib/Interfaces/ITemplate';
import IDeviceStorage from 'lib/Interfaces/IDeviceStorage';
import { isDeviceStorageArray } from './is-device-storage';
import { assignDeviceStorage } from './assign-device-storage';

/**
 * Syncs the disclosures in the templates with the disclosures in the array.
 * @param templates - Array of templates for all languages
 * @param disclosures - Array of disclosures to sync
 * @returns Updated templates with the disclosures synced
 */
export const syncTemplateDisclosures = (templates: ITemplate[], disclosures: IDeviceStorage[]): ITemplate[] => {
  if (!isDeviceStorageArray(disclosures)) {
    throw new Error('syncStorageInformation: Invalid disclosures');
  }

  return templates.map((template) => {
    const syncedDisclosures = disclosures.map((disclosure) => {
      const templateDisclosure = template.deviceStorage.disclosures.find(
        (d) => d.identifier === disclosure.identifier || d.name === disclosure.name,
      );

      if (templateDisclosure) {
        return assignDeviceStorage(templateDisclosure, disclosure);
      }

      // if the disclosure is not found in the template, add it to the template
      return {
        ...disclosure,
        id: disclosure.id + template.language,
        newStorage: true,
        description: '',
      };
    });

    return {
      ...template,
      deviceStorage: {
        ...template.deviceStorage,
        disclosures: syncedDisclosures,
      },
    };
  });
};
